<app-login-register-wrapper>
  <form
    [formGroup]="migrationForm"
    (ngSubmit)="onSubmit()"
    class="login-form"
    *ngIf="migrationForm"
  >
    <img class="emblem" src="/assets/img/img-login.png" alt="city-emblem"/>

    <small class="migration-information">
      {{ 'login.migration-information' | translate }}
    </small>

    <div class="input-row">
      <input
        type="text"
        formControlName="merchantId"
        class="input"
        name="merchant-number"
        id="merchant-number"
        [class.error]="migrationForm.errors && migrationForm.errors.conflict"
        [placeholder]="'login.form.placeholder.card' | translate"
      />
    </div>
    <div class="input-row">
      <input
        type="text"
        formControlName="email"
        class="input"
        name="merchant-email"
        id="merchant-email"
        [class.error]="migrationForm.errors && migrationForm.errors.conflict"
        [placeholder]="'login.form.placeholder.email' | translate"
      />
    </div>
    <div class="input-row with-caption">
      <input
        type="password"
        formControlName="password"
        class="input"
        [class.error]="migrationForm.errors && migrationForm.errors.wrongPassword"
        [placeholder]="'login.form.placeholder.current-pin' | translate"
      />
      <small (click)="onResetForm()">
        {{ "login.form.placeholder.not-your-card" | translate }}
      </small>
    </div>

    <div class="input-row" *ngIf="migrationForm.valid">
      <button type="submit" class="btn" [disabled]="!migrationForm.valid">
        <span>
          {{ "login.form.buttons.register" | translate }}
        </span>
      </button>
    </div>

    <div class="error-description">
      <div class="caption" *ngIf="migrationForm">
        <ng-container *ngIf="migrationForm.dirty && migrationForm.errors">
          <small>
            {{ "login.form.errors." + (migrationForm.errors | keyvalue)[0].key | translate }}
          </small>
        </ng-container>
      </div>
    </div>
  </form>
</app-login-register-wrapper>
